import React, { Component } from 'react'
import {
    Form, FormGroup, Label, Input, Row, Col, Button
} from 'reactstrap'
import './contacto.css'
import Contact from '../utilitarios/contacto'
import ReactPixel from 'react-facebook-pixel'
import ReactNotification from "react-notifications-component"
import "react-notifications-component/dist/theme.css"

const contacto = new Contact()

export default class Contacto extends Component {
    constructor(props) {
        super(props)

        this.state = {
            contacto: contacto
        }
        this.onChange = this.onChange.bind(this)
        this.enviarCorreo = this.enviarCorreo.bind(this)

        this.addNotification = this.addNotification.bind(this)
        this.notificationDOMRef = React.createRef()
    }

    onChange(e) {
        const contacto = {
            ...this.state.contacto,
            [e.target.id]: e.target.value
        }
        this.setState({
            contacto
        })
    }

    enviarCorreo(e) {
        e.preventDefault()
        ReactPixel.fbq('track','CompleteRegistration')
        const _this = this
        contacto.enviarCorreo(this.state.contacto).then(() => {
            _this.setState({
                contacto: contacto
            })
            _this.addNotification({
                title: 'Mensaje enviado!',
                message: 'Se ha enviado exitosamente su mensaje'
            })
        })
    }

    addNotification(notification) {
        this.notificationDOMRef.current.addNotification({
            title: notification.title,
            message: notification.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 2000 },
            dismissable: { click: true }
        });
    }

    render() {
        return (
            <div className="">
                <div className="">
                    <ReactNotification ref={this.notificationDOMRef} />
                    <Form onSubmit={this.enviarCorreo}>
                        <Row form>
                            <Col xs={12} md={6}>
                                <FormGroup>
                                    <Label for="Nombre" className="font-weight-bold">Nombre</Label>
                                    <Input onChange={this.onChange} value={this.state.contacto.Nombre} type="text" id="Nombre" placeholder="Nombre completo" required />
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={6}>
                                <FormGroup>
                                    <Label for="Correo" className="font-weight-bold">Correo</Label>
                                    <Input onChange={this.onChange} value={this.state.contacto.Correo} type="email" id="Correo" placeholder="Correo electrónico" required />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row form>
                            <Col>
                                <FormGroup>
                                    <Label for="Telefono" className="font-weight-bold">Teléfono</Label>
                                    <Input onChange={this.onChange} value={this.state.contacto.Telefono} type="number" id="Telefono" placeholder="Teléfono" />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row form>
                            <Col>
                                <FormGroup>
                                    <Label for="Mensaje" className="font-weight-bold">Mensaje</Label>
                                    <Input onChange={this.onChange} value={this.state.contacto.Mensaje} type="textarea" rows="3" id="Mensaje" placeholder="Escriba su mensaje" required />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row form>
                            <Col>
                                <Button color="warning" block>Enviar</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        )
    }

}

